import utilities from 'helptap-utilities';

export function extractLogoCharactersFromText(text, maxLength) {

  return utilities.general.getFirstCharactersOfWords(text, maxLength);

};